import React from 'react';

import ReorderIcon from '@mui/icons-material/Reorder';
import {
    Box,
    Checkbox,
    Divider,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
} from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { Draggable } from 'react-beautiful-dnd';
import { useTranslation } from 'react-i18next';

const SorteableItem = ({ columnsConfig, handleOnSelectItem, index, item }) => {
    const { t } = useTranslation();
    const itemData = columnsConfig[item.name];
    return (
        <Draggable draggableId={item.name} id={item.name} index={index}>
            {(provided) => (
                <Box
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                >
                    <ListItem
                        disablePadding
                        secondaryAction={
                            <Checkbox
                                checked={item.is_active}
                                disabled={item.required}
                                onChange={(e) =>
                                    handleOnSelectItem(
                                        item.name,
                                        e.target.checked,
                                    )
                                }
                            />
                        }
                    >
                        <ListItemButton>
                            <ListItemIcon>
                                <ReorderIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary={`${itemData?.prepend || ''}${t(
                                    itemData?.label,
                                )}${itemData?.append || ''}`}
                            />
                        </ListItemButton>
                    </ListItem>
                    <Divider />
                </Box>
            )}
        </Draggable>
    );
};

SorteableItem.propTypes = {
    columnsConfig: PropTypes.object,
    handleOnSelectItem: PropTypes.func,
    index: PropTypes.number,
    item: PropTypes.object,
};

export default SorteableItem;
